
/* =========================================================
   ATELIER FLOU — QUICK VIEW / APERÇU PRODUIT
   ========================================================= */

/* ---------------------------------------------------------
   01. Utilitaires
   --------------------------------------------------------- */

(() => {

  const escape = s => {
    const e = document.createElement('span');
    e.textContent = s || '';
    return e.innerHTML;
  };

  const money = n =>
    new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR'
    }).format(n / 100);


  /* -------------------------------------------------------
     02. État de l'aperçu
     ------------------------------------------------------- */

  let overlay;


  /* -------------------------------------------------------
     03. Ouverture de l'aperçu
     ------------------------------------------------------- */

  document.addEventListener('click', async e => {

    const trigger = e.target.closest('[data-preview]');

    if (!trigger) return;

    e.preventDefault();

    trigger.disabled = true;

    try {

      const r = await fetch(
        `/products/${encodeURIComponent(trigger.dataset.preview)}.js`
      );

      if (!r.ok) throw Error();

      const item = await r.json();


      /* ---------------------------------------------------
         04. Création de la fenêtre Quick View
         --------------------------------------------------- */

      overlay = document.createElement('div');

      overlay.className = 'quick-view-backdrop';

      overlay.innerHTML = `
        <div
          class="quick-view-panel"
          role="dialog"
          aria-modal="true"
          aria-label="Aperçu de ${escape(item.title).replaceAll('"', '&quot;')}"
        >

          <div class="quick-view-top">

            <span class="eyebrow">
              ATELIER FLOU · PARIS
            </span>

            <button
              type="button"
              data-preview-close
              aria-label="Fermer"
            >
              ✕
            </button>

          </div>


          <div class="af-bottle-quick af-bottle-render">

            <span
              class="af-bottle-glow"
              aria-hidden="true"
            ></span>

            <span
              class="af-bottle-shadow"
              aria-hidden="true"
            ></span>

            <div class="af-bottle-motion"></div>

          </div>


          <div class="quick-view-copy">

            <span class="eyebrow">
              EAU DE PARFUM
            </span>

            <h2></h2>

            <p></p>


            <div class="quick-view-price">

              <span>Format</span>

              <select
                aria-label="Choisir un format"
              ></select>

              <strong></strong>

            </div>


            <button
              class="af-button af-button-primary"
              type="button"
              data-preview-add
            >
              Ajouter au panier →
            </button>

            <p
              role="alert"
              data-preview-error
              hidden
            ></p>

            <a
              class="underlined-link"
              href="/products/${encodeURIComponent(item.handle)}"
            >
              Découvrir le parfum ↗
            </a>

          </div>

        </div>
      `;


      /* ---------------------------------------------------
         05. Insertion dans la page
         --------------------------------------------------- */

      document.body.append(overlay);

      document.body.style.overflow = 'hidden';


      /* ---------------------------------------------------
         06. Image du parfum
         --------------------------------------------------- */

      const photo = document.createElement('img');

      photo.className = 'af-bottle-image';
      photo.src = item.featured_image || '';
      photo.alt = item.title;

      overlay
        .querySelector('.af-bottle-motion')
        .append(photo);


      /* ---------------------------------------------------
         07. Informations produit
         --------------------------------------------------- */

      overlay.querySelector('h2').textContent = item.title;

      overlay.querySelector('.quick-view-copy p').textContent =
        item.description
          ?.replace(/<[^>]*>/g, '')
          .slice(0, 300) || '';


      /* ---------------------------------------------------
         08. Sélection du format
         --------------------------------------------------- */

      const select = overlay.querySelector('select');

      item.variants.forEach(v => {

        const opt = new Option(
          `${v.title}${v.available ? '' : ' — Épuisé'}`,
          v.id
        );

        opt.disabled = !v.available;

        select.add(opt);

      });


      /* ---------------------------------------------------
         09. Mise à jour du prix / disponibilité
         --------------------------------------------------- */

      const variant = () => {

        const v = item.variants.find(
          v => String(v.id) === select.value
        );

        overlay.querySelector('strong').textContent =
          money(v.price);

        overlay.querySelector('[data-preview-add]').disabled =
          !v.available;

      };

      variant();

      select.addEventListener('change', variant);


      /* ---------------------------------------------------
         10. Bouton Ajouter au panier
         --------------------------------------------------- */

      overlay.querySelector('[data-preview-add]').onclick =
        async () => {

          const btn =
            overlay.querySelector('[data-preview-add]');

          btn.disabled = true;

          const error =
            overlay.querySelector('[data-preview-error]');

          try {

            const result = await fetch(
              '/cart/add.js',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: Number(select.value),
                  quantity: 1
                })
              }
            );

            if (!result.ok) {
              throw Error(
                'Impossible d’ajouter cet article.'
              );
            }

            overlay.remove();
            overlay = null;

            document.body.style.overflow = '';

            document
              .querySelector('[data-cart-open]')
              .click();

            document
              .querySelector('[data-cart-notice]')
              .hidden = false;

          } catch (err) {

            error.textContent = err.message;
            error.hidden = false;

          } finally {

            btn.disabled = false;

          }

        };


      /* ---------------------------------------------------
         11. Fermeture directe par la croix
         --------------------------------------------------- */

      const closeButton =
        overlay.querySelector('[data-preview-close]');

      closeButton.addEventListener('click', () => {

        if (!overlay) return;

        overlay.remove();

        overlay = null;

        document.body.style.overflow = '';

      });


      /* ---------------------------------------------------
         12. Focus sur la croix
         --------------------------------------------------- */

      closeButton.focus();


    } catch {

      location.href =
        `/products/${encodeURIComponent(trigger.dataset.preview)}`;

    } finally {

      trigger.disabled = false;

    }

  });


  /* -------------------------------------------------------
     13. Fermeture en cliquant sur le fond ou la croix
     ------------------------------------------------------- */

  document.addEventListener('click', e => {

    if (
      overlay &&
      (
        e.target === overlay ||
        e.target.closest('[data-preview-close]')
      )
    ) {

      overlay.remove();

      overlay = null;

      document.body.style.overflow = '';

    }

  });


  /* -------------------------------------------------------
     14. Fermeture avec la touche Échap
     ------------------------------------------------------- */

  document.addEventListener('keydown', e => {

    if (
      overlay &&
      e.key === 'Escape'
    ) {

      overlay.remove();

      overlay = null;

      document.body.style.overflow = '';

    }

  });

})();